import {Game} from '../Game';
import {SetWallPieceAction} from 'src/Action';

export class SetWallPiece {
    public constructor(public game: Game) {
        // Sets instance variables
    }

    public byServer(action: SetWallPieceAction): void {
        this.game.players[action.index].wallPiece = action.tiles;
    }
}



// WEBPACK FOOTER //
// ./src/game/actions/SetWallPiece.ts